[
  {
    "name": "Stella de Oro",
    "image": "https://avatars.mds.yandex.net/i?id=9ddcb7a99fdd86f8c81d0f80670c6a97_l-12323487-images-thumbs&n=13",
    "bloom_time": "Червень - Жовтень",
    "fact": "Один з найпопулярніших сортів у світі завдяки рекордно тривалому цвітінню."
  },
  {
    "name": "Black Stockings",
    "image": "https://avatars.mds.yandex.net/i?id=fea7dc89522e01730765c61849add135_l-5480941-images-thumbs&n=13",
    "bloom_time": "Липень - Серпень",
    "fact": "Має глибокий темно-пурпуровий, майже чорний колір пелюсток з гофрованими краями."
  },
  {
    "name": "Catherine Woodbery",
    "image": "https://avatars.mds.yandex.net/i?id=28b48d6f42bf88481a22dc8f5c8165d687ae03f5-12421994-images-thumbs&n=13",
    "bloom_time": "Кінець червня",
    "fact": "Квіти мають ніжний аромат та змінюють відтінок залежно від освітлення."
  },
  {
    "name": "Crimson Pirate",
    "image": "https://api.sflora.ru/storage/uploads/product/3485/14-scaled-e1611147012696.jpg",
    "bloom_time": "Червень - Липень",
    "fact": "Класичний яскраво-червоний сорт, який дуже швидко розростається."
  },
  {
    "name": "Bela Lugosi",
    "image": "https://avatars.mds.yandex.net/i?id=9115f8729c442d65cfba5a87f8c5b4e7eeb65eae-10907478-images-thumbs&n=13",
    "bloom_time": "Липень",
    "fact": "Названий на честь актора, що грав Дракулу, через свій містичний вигляд."
  },
  {
    "name": "Double River Wye",
    "image": "https://avatars.mds.yandex.net/i?id=2565b42f9de1973af1ed3506f0ab27575cf4a24e-4909855-images-thumbs&n=13",
    "bloom_time": "Червень - Серпень",
    "fact": "Має незвичну махрову структуру квітки (подвійний ряд пелюсток)."
  },
  {
    "name": "Moonlit Masquerade",
    "image": "https://avatars.mds.yandex.net/i?id=2ee5316898cb8df4f72f5232f4eb3c134ed422cf-8981391-images-thumbs&n=13",
    "bloom_time": "Липень",
    "fact": "Виділяється контрастним темно-фіолетовим 'оком' у центрі кремової квітки."
  },
  {
    "name": "Pardon Me",
    "image": "https://avatars.mds.yandex.net/i?id=6b9b2f81147355fed7056f03431eba15e363340f-4120924-images-thumbs&n=13",
    "bloom_time": "Липень - Вересень",
    "fact": "Мініатюрний сорт, який часто цвіте повторно в кінці літа."
  },
  {
    "name": "Strawberry Candy",
    "image": "https://avatars.mds.yandex.net/i?id=086fd35cbec004a7e2005f5e10c0917f_l-8178604-images-thumbs&n=13",
    "bloom_time": "Червень - Липень",
    "fact": "Отримав багато нагород за свій унікальний рожево-кораловий колір."
  },
  {
    "name": "Big Smile",
    "image": "https://www.kamelia-gardens.ru/img/work/nomencl/28924.jpg",
    "bloom_time": "Липень",
    "fact": "Велика квітка з жовтою серединою та ніжними рожевими краями."
  },
  {
    "name": "Night Embers",
    "image": "https://gardencolors.ru/wp-content/uploads/2025/12/nighe-embers.webp",
    "bloom_time": "Кінець червня",
    "fact": "Махрові квіти насиченого вишневого кольору з золотистою облямівкою."
  },
  {
    "name": "Free Wheelin",
    "image": "https://www.pervocvet-shop.ru/img/work/nomencl/a_27741_6584.jpg",
    "bloom_time": "Липень",
    "fact": "Належить до типу 'спайдер' — має дуже довгі та вузькі пелюстки."
  },
  {
    "name": "Destined to See",
    "image": "https://vsesorta.ru/upload/resize_cache/iblock/252/730_400_1/601448-lileynik-gibridnyy-destind-tu-si.jpg",
    "bloom_time": "Липень",
    "fact": "Має лавандові краї та неймовірний аромат, що відчутний на відстані."
  },
  {
    "name": "Franz Hals",
    "image": "https://avatars.mds.yandex.net/i?id=d0bc0b08d284e9c51ae684bc99f8cf3ffa18a310-7947652-images-thumbs&n=13",
    "bloom_time": "Серпень",
    "fact": "Двоколірний сорт: три пелюстки помаранчеві, а три — цегляно-червоні."
  },
  {
    "name": "Chicago Apache",
    "image": "https://avatars.mds.yandex.net/i?id=2b8edc1a9c5e6b002c90735bf723a6500e90a50f-5242958-images-thumbs&n=13",
    "bloom_time": "Липень - Серпень",
    "fact": "Вважається одним з найстійкіших червоних лілійників до сонячного вигорання."
  },
  {
    "name": "Gentle Shepherd",
    "image": "https://avatars.mds.yandex.net/i?id=073c26047c8f2ab6ac50c53ea3a32a7ee3f52d6f-5665918-images-thumbs&n=13",
    "bloom_time": "Червень",
    "fact": "Довгий час вважався найбілішим сортом серед лілійників."
  },
  {
    "name": "Purple d'Oro",
    "image": "https://avatars.mds.yandex.net/i?id=84e7e50bb875c8ccd108e3fd3bc90abee681e1a9-8406302-images-thumbs&n=13",
    "bloom_time": "Травень - Вересень",
    "fact": "Компактний кущ, ідеальний для вирощування у великих горщиках."
  },
  {
    "name": "EveryDaylily Red",
    "image": "https://avatars.mds.yandex.net/i?id=8e23e42a554404f5422fbe98841363e6614a7606-4519223-images-thumbs&n=13",
    "bloom_time": "Червень - Жовтень",
    "fact": "Сучасна серія сортів, виведена спеціально для безперервного цвітіння."
  },
  {
    "name": "Tiger Swirl",
    "image": "https://avatars.mds.yandex.net/i?id=b664a6f5971a82bc030821314f50848876a96bab-12384085-images-thumbs&n=13",
    "bloom_time": "Липень",
    "fact": "Величезна квітка трикутної форми з незвично закрученими пелюстками"
  },
  {
    "name": "Sabine Baur",
    "image": "https://avatars.mds.yandex.net/i?id=84df752edc501a1401e16c808bc06670b1d14cbd-4080492-images-thumbs&n=13",
    "bloom_time": "Червень",
    "fact": "Має дуже чіткий графічний малюнок на пелюстках, схожий на екзотичну маску."
  }

]